import React, { useState } from 'react';
import { PropsWithChildren } from 'react';
import agent from '../agent';
import { JobApplicationViewType } from '../types/services-api';

export type ApplicationsContextType = {
  applicationList?: JobApplicationViewType[];
  updateStaffApplications: (
    additionalApplication: JobApplicationViewType
  ) => void;
  applicationFetchError: string;
  fetchApplications: () => void;
};

export const ApplicationsContext = React.createContext<ApplicationsContextType>(
  {
    updateStaffApplications: (additionalApplication) => {},
    applicationFetchError: '',
    fetchApplications: () => {},
  }
);

export function isApplication(obj: any): obj is JobApplicationViewType {
  return 'reviewedDate' in obj;
}

const ApplicationsContextWrapper = (props: PropsWithChildren) => {
  const [applications, setApplications] = useState<JobApplicationViewType[]>();
  const [errorMessage, setErrorMessage] = useState<string>('');

  function fetchApplications() {
    agent.Staff.applications()
      .then((res) => {
        setApplications(res.data);
      })
      .catch((err) => {
        setApplications([]);
        setErrorMessage(err.message);
      });
  }

  function updateStaffApplications(
    additionalApplication: JobApplicationViewType
  ) {
    if (!!applications) {
      setApplications([additionalApplication, ...applications]);
    }
  }

  //for DevTools to display context name
  ApplicationsContext.displayName = 'Applications Context';

  return (
    <ApplicationsContext.Provider
      value={{
        fetchApplications,
        applicationList: applications,
        updateStaffApplications,
        applicationFetchError: errorMessage,
      }}
    >
      {props.children}
    </ApplicationsContext.Provider>
  );
};

export default ApplicationsContextWrapper;
